import { Injectable } from '@angular/core';
import { CalculationTimeAndAttendanceDto } from '@shared/service-proxies/service-proxies';
import { ReplaySubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DashboardUserTimeDataService {
    private readonly userTimeDetailsSubject = new ReplaySubject<CalculationTimeAndAttendanceDto>(1);

    readonly userTimeDetails$ = this.userTimeDetailsSubject.asObservable();

    setUserTimeDetails(data: CalculationTimeAndAttendanceDto): void {
        this.userTimeDetailsSubject.next(data);
    }
}
